// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__EM2vX","slideOutUp":"Welcome_slideOutUp__BZYDn"};